import * as IntegrationsActions from "./IntegrationsActions";

export default IntegrationsActions;
